import nextId from "react-id-generator"
import drmartens13 from "../../images/drmartens13.png"
import drmartens24 from "../../images/drmartens24.png"
import drmartens2 from "../../images/drmartens2.png"
import drmartens5 from "../../images/drmartens5.png"

export const boots = [
    {
        id: nextId(),
        image: drmartens13,
        name: "dr martens boots",
        price: "£199.99"
    },
    {
        id: nextId(),
        image: drmartens24,
        name: "dr martens boots",
        price: "£199.99"
    },
    {
        id: nextId(),
        image: drmartens2,
        name: "dr martens boots",
        price: "£199.99"
    },
    {
        id: nextId(),
        image: drmartens5,
        name: "dr martens boots",
        price: "£199.99"
    },
    
]